module.exports = " <div class=weui_progress> <div class=weui_progress_bar> <div class=\"weui_progress_inner_bar js_progress\" :style=\"{width: percent + '%'}\"></div> </div> <a href=javascript:; class=weui_progress_opr v-show=showCancel> <i class=weui_icon_cancel @click=cancel></i> </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/progress/index.vue
// module id = 237
// module chunks = 2